export default __webpack_public_path__ + "static/media/ic_georgia.af59a913.svg";